var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import "@gouvfr/dsfr/dist/component/header/header.css";
import classNames from "classnames";
import { Link } from "../../Link";
/**
 *
 * @visibleName HeaderOperatorMj
 */
var HeaderOperatorMj = function (props) {
    // @ts-ignore
    var children = props.children, source = props.source, label = props.label, to = props.to, title = props.title, className = props.className, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["children", "source", "label", "to", "title", "className", "__TYPE"]);
    var imageStyleWidth = {
        maxWidth: "9.0625rem",
    };
    var _classNames = classNames(className, "fr-header__operator");
    return (React.createElement("div", __assign({ className: _classNames, "data-type": __TYPE }, remainingProps),
        to && (React.createElement(Link, { to: to, as: "a", title: title },
            React.createElement("img", { className: "fr-responsive-img", style: imageStyleWidth, src: source, alt: label }))),
        !to && (React.createElement("img", { className: "fr-responsive-img", style: imageStyleWidth, src: source, alt: label }))));
};
HeaderOperatorMj.defaultProps = { __TYPE: "HeaderOperatorMj" };
HeaderOperatorMj.propTypes = { __TYPE: PropTypes.string };
export default HeaderOperatorMj;
